import { FC } from "react";
import { Box, makeStyles, Theme } from "@material-ui/core";
import { some } from "lodash";

import { Image, RoyaltyPayorLogo } from "components";
import { RoyaltyPayor } from "services/royaltyPayor/types";
import theme from "theme";

import CanGetValuationIcon from "./CanGetValuationIcon";

const useStyles = makeStyles<
  Theme,
  {
    containerPadding: boolean;
    height: string;
    minWidth: string;
    royaltyPayorLogoMaxHeight: string;
  }
>(() => ({
  container: {
    position: "relative",
    height: props => (props.height ? props.height : "70px"),
    width: "100%",
    minWidth: props => (props.minWidth ? props.minWidth : "120px"),
    padding: props => (props.containerPadding ? theme.spacing(2, 4) : 0),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  royaltyPayorLogo: {
    maxHeight: props => props.royaltyPayorLogoMaxHeight || "unset",
    maxWidth: "100px",
  },
  royxLogo: {
    height: "40px",
    objectFit: "contain",
  },
  canGetValuationIcon: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(0.5),
  },
}));

const RoyaltyPayorImage: FC<{
  containerPadding?: boolean;
  height?: string;
  minWidth?: string;
  royaltyPayor?: RoyaltyPayor;
  displayCanGetValuationIcon?: boolean;
  royaltyPayorLogoMaxHeight?: string;
}> = ({
  containerPadding = true,
  height,
  minWidth,
  royaltyPayor,
  displayCanGetValuationIcon = true,
  royaltyPayorLogoMaxHeight,
}) => {
  const classes = useStyles({
    containerPadding,
    height,
    minWidth,
    royaltyPayorLogoMaxHeight,
  });
  const { logo_image, display_name } = royaltyPayor || {};
  const canGetValuation = some(royaltyPayor?.permissions, {
    codename: "get_valuation",
  });
  return (
    <Box className={classes.container}>
      {!!royaltyPayor ? (
        <RoyaltyPayorLogo
          displayName={display_name}
          logoImage={logo_image}
          className={classes.royaltyPayorLogo}
        />
      ) : (
        <Image
          name="re-logo.svg"
          alt="Royalty Exchange Logo"
          className={classes.royxLogo}
        />
      )}
      {displayCanGetValuationIcon && (
        <Box className={classes.canGetValuationIcon}>
          <CanGetValuationIcon
            canGetValuation={canGetValuation}
            showLabel={false}
          />
        </Box>
      )}
    </Box>
  );
};

export default RoyaltyPayorImage;
